module.exports = __webpack_public_path__ + "static/media/toyota-bumper_selected.698239c4.svg";